<script>
    import Icon from './Icon.svelte';
    import { style } from '../../lib/store.js';

    export let text         = '';
    export let href         = '';
    export let cta          = '';
    export let action       = () => {};
    export let icon         = '';
    export let outline      = false;
    export let large        = false;
    export let fluid        = false;
    export let alignBetween = false;
    export let lightMode = false;
</script>

<div
    class:cta-btn={true}
    class:sky-blue={!cta}
    class:outline
    class:large
    class:fluid
    class:alignBetween
    class={style}
>
    <a
        href={href || undefined}
        class:lightMode
        on:click={action}
    >
        {text}
        <span class="icon">
            {#if icon}
                <Icon name={icon} size={11} color="white" />
            {/if}
        </span>
    </a>
</div>

<style lang="scss">
    a {
        height: 100%;
        display: flex !important;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .fluid {
        width: 100%;
    }

    .large {
        height: 51px;
    }

    .icon {
        margin-left: 14px;
        line-height: 0;
    }

    .outline {
        background-color: transparent;
        color: var(--c-primary);
    }

    .alignBetween {
        a {
            justify-content: space-between;
        }
    }

    // Syle overwrites
    .WBS{
        a{
            background-color: #1D1D1A;
            text-decoration: none;
            color: white;
            transition: all 0.3s ease-in-out;
            min-height: 40px;
            border-radius: 6px;
            &.lightMode{
                background-color: var(--c-primary);
            }
            &:hover{
                opacity: .5;
                color: white !important;
            }
        }
    }
</style>
